@import '../../../globals/main.scss';

pn-charts-card {
  width: 100%;
  height: 100%;
  display: flex;

  .pn-charts-card__wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;

    border-radius: 2.4rem;
    padding: 2.4rem;

    @media screen and (min-width: $min-width-xl) {
      padding: 3.2rem;
    }
  }

  .pn-charts-card__heading__wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 0.8rem;
  }

  .pn-charts-card__heading {
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 110%;

    @media screen and (min-width: $min-width-xxl) {
      font-size: 3.2rem;
    }
  }

  .pn-charts-card__heading__highlight {
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 110%;
    color: $blue700;

    @media screen and (min-width: $min-width-xxl) {
      font-size: 3.2rem;
    }
  }

  .pn-charts-card__content__wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .pn-charts-card__text__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  .pn-charts-card__heading__wrapper--horizontal {
    display: none;
  }

  .pn-charts-card__text__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    span {
      display: block;
      margin-bottom: 5.4rem;
    }
  }

  .pn-charts-card__preamble {
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 140%;
    flex-grow: 1;
    margin-bottom: 1.6rem;

    @media screen and (min-width: $min-width-xxl) {
      font-size: 2rem;
    }
  }

  .pn-charts-card__source {
    display: flex;
    flex-direction: column;

    label {
      background-color: $blue700;
      color: $white;
      border-radius: 0.4rem;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1;
      text-transform: uppercase;
      padding: 0.4rem;
      margin-bottom: 0.6rem;
      width: fit-content;

      @media screen and (min-width: $min-width-xxl) {
        font-size: 1.2rem;
        padding: 0.6rem;
      }
    }

    .pn-chart-card__text__heading {
      font-weight: 400;
      font-size: 1.6rem;
      line-height: 140%;
      color: $blue700;
      margin-bottom: 0;

      @media screen and (min-width: $min-width-xxl) {
        font-size: 2rem;
      }
    }

    a {
      text-decoration: none;
      color: $blue700;
      &:hover {
        text-decoration: underline;
      }

      font-weight: 500;
      font-size: 1.6rem;
      text-decoration: none;
      color: $blue700;
      font-weight: 400;

      @media screen and (min-width: $min-width-xxl) {
        font-size: 2rem;
      }

      pn-icon svg {
        path {
          fill: $blue700;
        }
      }

      &[target='_blank']:not(.pn-button):after {
        display: none;
      }
    }
  }
}

//horizontal layout
.fullwidth {
  & > pn-charts-card {
    .pn-charts-card__wrapper {
      padding: 2.4rem;
      @media screen and (min-width: $min-width-lg) {
        padding: 4rem;
      }
    }

    .pn-charts-card__heading__wrapper {
      margin-bottom: 3.2rem;
      @media screen and (min-width: $min-width-md) {
        justify-content: flex-start;
      }

      gap: 1.6rem;
    }

    .pn-charts-card__heading,
    .pn-charts-card__heading__highlight {
      font-size: 2.4rem;
      @media screen and (min-width: $min-width-md) {
        font-size: 3.2rem;
      }
    }

    .pn-charts-card__content__wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      @media screen and (min-width: $min-width-lg) {
        flex-direction: row-reverse;
        gap: 5.6rem;
      }

      @media screen and (min-width: $min-width-xl) {
        gap: 4rem;
      }

      @media screen and (min-width: $min-width-xxl) {
        gap: 3.2rem;
      }
    }

    .pn-charts-card__text__container {
      justify-content: center;
      @media screen and (min-width: $min-width-md) {
        width: 100%;
      }
    }

    .pn-charts-card__heading__wrapper--vertical {
      display: flex;

      @media screen and (min-width: $min-width-lg) {
        display: none;
      }
    }

    .pn-charts-card__heading__wrapper--horizontal {
      display: none;
      @media screen and (min-width: $min-width-lg) {
        display: flex;
      }
    }

    .pn-charts-card__preamble {
      @media screen and (min-width: $min-width-md) {
        flex-grow: 0;
        font-size: 2rem;
      }
    }
  }
}

//colors
pn-charts-card[data-chart-color='blue'] {
  & > .pn-charts-card__wrapper {
    background-color: $blue25;
  }
}

pn-charts-card[data-chart-color='coral'] {
  & > .pn-charts-card__wrapper {
    background-color: $coral50;
  }
}

pn-charts-card[data-chart-color='green'] {
  & > .pn-charts-card__wrapper {
    background-color: $green50;
  }
}

pn-charts-card[data-chart-color='white'] {
  & > .pn-charts-card__wrapper {
    background-color: $white;
  }
}

pn-charts-card[data-chart-color='gray'] {
  & > .pn-charts-card__wrapper {
    background-color: $gray25;
  }
}
